import $ from 'jquery';

function Modal(){
    // alert('hello modal');
    var openModal = $('.openModal');
    var closeModal = $('.closeModal');
    var modal = $('.modal');
    var opened = 0;


    if ($(window).width() < 600){
        openModal.on('click', function(){
            modal.css('display', 'flex');
            setTimeout(() => {  // This timeout ensures that the CSS transition runs
                modal.css('bottom', '0px'); // This sets the height to 100% to make it slide from bottom
            }, 10);
            $("body").css("overflow", "hidden");

            if(opened == 0){
                dataLayer.push({
                    event: 'step1'
                });
            }
            opened = 1;
        })

        closeModal.on('click', function(){
            modal.css('bottom', '-100vh'); // This sets the height to 100% to make it slide from bottom
            setTimeout(() => {  // This timeout ensures that the CSS transition runs
                modal.css('display', 'none');
                $("body").css("overflow","auto");
                $("body").css("overflow-x","hidden");
            }, 500);

        })
    }else{
        openModal.on('click', function(){
            modal.css('display', 'flex');
            $("body").css("overflow","hidden");

            if(opened == 0){
                dataLayer.push({
                    event: 'step1'
                });
            }
            opened = 1;
        })

        closeModal.on('click', function(){
            $('.modal').css('display', 'none');
            $("body").css("overflow","auto");
            $("body").css("overflow-x","hidden");
        })
    }
}

export default Modal;